import classNames from 'classnames';
import React from 'react';
import aiCopilot from '../images/empty/ai-copilot.svg';
import connections from '../images/empty/connections.svg';
import genericAlt from '../images/empty/generic-alt.svg';
import generic from '../images/empty/generic.svg';
import googleDrive from '../images/empty/google-drive.svg';
import notFound from '../images/empty/not-found.svg';
import notifications from '../images/empty/notifications.svg';
import posts from '../images/empty/posts.svg';
import slack from '../images/empty/slack.svg';
import templates from '../images/empty/templates.svg';
import * as styles from './EmptyState.module.scss';

const IMAGES = {
  generic,
  connections,
  genericAlt,
  googleDrive,
  notFound,
  notifications,
  posts,
  slack,
  templates,
  aiCopilot,
} as const;

interface EmptyStateProps {
  action?: React.ReactNode;
  imageName?: keyof typeof IMAGES;
  message?: React.ReactNode | null;
  title?: string;
  vertical?: boolean;
  smallText?: boolean;
  smallIcon?: boolean;
  noMargin?: boolean;
}

const EmptyState = ({
  action = null,
  imageName = 'generic',
  message = null,
  title,
  vertical = false,
  smallText = false,
  smallIcon = false,
  noMargin = false,
}: EmptyStateProps) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.vertical]: vertical,
        [styles.smallText]: smallText,
        [styles.smallIcon]: smallIcon,
        [styles.noMargin]: noMargin,
      })}
    >
      <div className={styles.left}>
        <img src={IMAGES[imageName] ?? generic} alt="" />
      </div>
      {(title || !!message || !!action) && (
        <div className={styles.right}>
          {!!title && <h2 className={styles.title}>{title}</h2>}
          {!!message && <div className={styles.message}>{message}</div>}
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
